import * as React from 'react';
import Divider from '@mui/material/Divider';
import type {} from '@mui/material/themeCssVarsAugmentation';
import DashboardSidebarContext from '../context/DashboardSidebarContext';
import { getDrawerSxTransitionMixin } from '../mixins';

export default function DashboardSidebarDividerItem() {
  const sidebarContext = React.useContext(DashboardSidebarContext);
  if (!sidebarContext) {
    throw new Error('Sidebar context was used without a provider.');
  }
  const { fullyExpanded = true, hasDrawerTransitions } = sidebarContext;

  return (
    <li>
      <Divider
        sx={(theme) => ({
          borderBottomWidth: 1,
          my: 1.5,
          mx: 1,
          opacity: 0.6,
          borderColor: 'rgba(0, 0, 0, 0.08)',
          ...theme.applyStyles('dark', {
            opacity: 0.8,
            borderColor: 'rgba(255, 255, 255, 0.15)',
            boxShadow: '0 1px 0 rgba(255, 255, 255, 0.05)',
          }),
          ...(hasDrawerTransitions
            ? getDrawerSxTransitionMixin(fullyExpanded, 'margin')
            : {}),
        })}
      />
    </li>
  );
}
